import type {Media} from '@pexip/media';

import {useAnalyzer} from './useAnalyzer';

/**
 * Derive the analyzer from the preview state without another controller subscription.
 * @example const analyzer = usePreviewAnalyzer(previewMedia);
 */
export const usePreviewAnalyzer = (media: Media | undefined) =>
    useAnalyzer(media?.getAudioTracks()[0]?.source.track);
